import React from "react";
import PageHeader from "@/components/PageHeader";
import SEO from "@/components/SEO";
import { PRODUCTS } from "@/lib/constants";
import { Link } from "react-router-dom";

export default function Coverage() {
    return (
        <div data-testid="coverage-page">
            <SEO
                title="Coverage — Term, Whole Life, IUL, Annuities & more"
                description="Eight lines of coverage, one independent advisor: Term, Whole Life, IUL, Final Expense, Annuities, Health, Medicare, Dental & Vision."
            />
            <PageHeader
                eyebrow="Coverage"
                title="Eight lines of coverage, one advisor."
                subtitle="Independent guidance across the products most families and business owners actually use."
            />

            <section className="mm-section bg-white">
                <div className="mm-container space-y-8">
                    {PRODUCTS.map((p) => {
                        const Icon = p.icon;
                        const anchor = p.key.toLowerCase().replace(/[^a-z]/g, "-");
                        return (
                            <article
                                key={p.key}
                                id={anchor}
                                className="mm-card grid gap-6 p-8 md:grid-cols-[auto_1fr_auto] md:items-center"
                                data-testid={`coverage-row-${anchor}`}
                            >
                                <div className="inline-flex h-14 w-14 items-center justify-center rounded-2xl bg-gradient-to-br from-mm-navy to-mm-blue text-white">
                                    <Icon size={22} />
                                </div>
                                <div>
                                    <h2 className="mm-display text-2xl text-mm-navy">
                                        {p.title}
                                    </h2>
                                    <p className="mt-2 text-mm-muted leading-relaxed">
                                        {p.long}
                                    </p>
                                </div>
                                <Link
                                    to="/#lead-form"
                                    className="mm-btn-outline whitespace-nowrap"
                                >
                                    Talk about {p.title}
                                </Link>
                            </article>
                        );
                    })}
                </div>
            </section>
        </div>
    );
}
